<script>
    export let params;
    let path = '';
    $: path = (params && params.path) ? params.path : '';

    export let isChild = false;

    export let opened = false;

    function toggleOpened() {
        opened = !opened;
    }
</script>

<div data-item="tutorial-item" class={`tutorial-${isChild ? 'sub' : ''}section ${opened ? 'open' : ''}`}>
    <div data-type="opener" class={`tutorial-${isChild ? 'sub' : ''}section__header`}  on:click={toggleOpened}>
        <h2 name="title" class={`tutorial-${isChild ? 'sub' : ''}section__title`}>
            <slot name="title">Section title</slot>
        </h2>
        <div class={`tutorial-${isChild ? 'sub' : ''}section__more-btn`}>
            <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.25 1.34998L6.70711 5.89287C6.31658 6.28339 5.68342 6.28339 5.29289 5.89287L0.75 1.34997" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </div>
    </div>
    <div class={`tutorial-${isChild ? 'sub' : ''}section__body`}>
        <slot name="content">Section content</slot>
    </div>
</div>